import styled from 'styled-components';
import { media } from 'designsystem/index';

const RightButtonWrapper = styled.div`
  position: absolute;
  top: 215px;
  right: 0;
  z-index: 25;
  padding-right: 20px;

  ${media.tablet`
    top: 255px;
 `};

  ${media.desktop`
    top: 240px;
  `};
`;

export default RightButtonWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/RightButtonWrapper.jsx